import HeaderSubSection from "../../components/HeaderSubSection/index.vue";
import contactSection from "../../components/contactSection/index.vue";

export default {
  name: "homePage",
  components: {
    HeaderSubSection,
    contactSection,
  },
};
